"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SupportScores;
(function (SupportScores) {
  SupportScores["quiet"] = "quiet";
  SupportScores["safety"] = "safety";
  SupportScores["errand"] = "errand";
  SupportScores["traffic"] = "traffic";
  SupportScores["entertainment"] = "entertainment";
})(SupportScores = exports.SupportScores || (exports.SupportScores = {}));
exports.findIdByScore = function (score, descriptions) {
  return Object.keys(descriptions).sort(function (a, b) {
    return Number(a) - Number(b);
  }).find(function (value) {
    return score <= Number(value);
  });
};
exports.findOrDefaultByScore = function (score, descriptions) {
  return exports.findIdByScore(score, descriptions) || Math.floor(Object.keys(descriptions).length / 2);
};
exports.parseType = function (type) {
  return type === 'safety' ? 'Road Safety' : "" + type.charAt(0).toLocaleUpperCase() + type.slice(1);
};